import React from "react";
import { JsonPropsType } from "../../component-loader";
import { Toaster } from "../common/Toaster";
import { WithQueryClient } from "../common/WithQueryClient";
import { FileExplorerContextProvider } from "./Context/FileExplorerContext";
import { FileExplorerDragProvider } from "./Context/FileExplorerDndContext";
import { FileExplorerBreadcrumb } from "./FileExplorerBreadcrumb";
import { FileExplorerDropdown } from "./FileExplorerDropdown";
import { FileExplorerFileTree } from "./FileExplorerFileTree";
import { FileExplorerGrid } from "./FileExplorerGrid";
import { FileExplorerMoveModal } from "./FileExplorerMoveModal";

interface FileExplorerWrapperProps {
  isSuperuser: boolean;
}

export function FileExplorerWrapper(props: JsonPropsType) {
  const { isSuperuser } = props.jsonObject as FileExplorerWrapperProps;
  return (
    <>
      <WithQueryClient>
        <FileExplorerContextProvider userIsSuperuser={isSuperuser}>
          <FileExplorerDragProvider>
            <div className="container-fluid">
              <div className="row mb-4">
                <div className="col-12 d-flex justify-content-between align-items-end">
                  <FileExplorerDropdown />
                  <FileExplorerBreadcrumb />
                </div>
              </div>
              <div className="row g-4">
                <div className="file-explorer-container col-12 col-xl-4">
                  <FileExplorerFileTree />
                </div>
                <div className="file-explorer-container col-12 col-xl-8">
                  <FileExplorerGrid />
                </div>
              </div>
            </div>
            <FileExplorerMoveModal />
          </FileExplorerDragProvider>
        </FileExplorerContextProvider>
      </WithQueryClient>
      <Toaster />
    </>
  );
}
